import { render, staticRenderFns } from "./TabsVertical.vue?vue&type=template&id=ecdadd74&scoped=true&"
import script from "./TabsVertical.vue?vue&type=script&lang=js&"
export * from "./TabsVertical.vue?vue&type=script&lang=js&"
import style0 from "./TabsVertical.vue?vue&type=style&index=0&id=ecdadd74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdadd74",
  null
  
)

export default component.exports